import { Stack, Box } from "@mui/material"
import { useTheme } from '@mui/material';

export default function Progress({value}){

    const theme = useTheme();

    const primary = theme.palette.info.main;

    let val = Math.round(value || 0) + '%';

    let barSx = {
        backgroundColor: 'rgb(230,230,230)',
        height: 5,
        borderRadius: 2.5,
        width: '100%'
    };

    let progressSx = {
        backgroundColor: primary,
        height: 5,
        borderRadius: 2.5,
        width: val
    }

    let valueSx = {
        fontSize: '0.9em',
        color: value === 100 ? primary : 'inherit'
    }

    return <Stack direction='row' alignItems='center' spacing={1}>

            <Box sx={barSx}>
                <Box sx={progressSx}/>
            </Box>

            <Box sx={valueSx}>{val}</Box>

    </Stack>
}